/**
 * Paging over a list already in memory.
 *
 * The lists here are bounded by the API, so this is about reading
 * comfort rather than data volume: forty notices in one scroll is
 * where you lose your place, not where the browser struggles.
 */
export const PAGE = 12;

export const Pager = ({ page, count, onPage }: {
  page: number;
  count: number;
  onPage: (n: number) => void;
}) => {
  const pages = Math.ceil(count / PAGE);
  if (pages <= 1) return null;

  return (
    <div className="pager">
      <button disabled={page === 0} onClick={() => onPage(page - 1)}>
        Previous
      </button>
      <span className="sub">
        Page {page + 1} of {pages}
      </span>
      <button
        disabled={page >= pages - 1}
        onClick={() => onPage(page + 1)}
      >
        Next
      </button>
    </div>
  );
};
